module.exports = __webpack_public_path__ + "img/zbdwz.a743ae3e.svg";